import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes, faSpinner } from '@fortawesome/free-solid-svg-icons';

const RegenerateDocumentModal = ({ isOpen, onClose, onConfirm, document, loading, getAssigneeName }) => {
  if (!isOpen || !document) return null;

  return (
    <div className="modal-overlay">
      <div className="modal-container">
        <div className="modal-header">
          <h2>Regenerate Document</h2>
          <button className="close-button" onClick={onClose}>
            <FontAwesomeIcon icon={faTimes} />
          </button>
        </div>
        <div className="modal-content">
          <p>Are you sure you want to regenerate this document?</p>
          <div className="document-details">
            <div className="detail-row">
              <span className="detail-label">Document Name:</span>
              <span className="detail-value">{document.documentTitle || "Untitled"}</span>
            </div>
            <div className="detail-row">
              <span className="detail-label">Assignee:</span>
              <span className="detail-value">{getAssigneeName(document.assigneeId)}</span>
            </div>
            <div className="detail-row">
              <span className="detail-label">Uploaded:</span>
              <span className="detail-value">
                {document.timestamp ? new Date(document.timestamp).toLocaleString() : 'Unknown'}
              </span>
            </div>
          </div>
          <p style={{ marginTop: '15px', color: '#666', fontSize: '14px' }}>
            This will create new AI-generated content for the document, replacing the current content.
          </p>
        </div>
        <div className="modal-actions">
          <button className="cancel-button" onClick={onClose} disabled={loading}>
            Cancel
          </button>
          <button className="regenerate-confirm-button" onClick={onConfirm} disabled={loading}>
            {loading ? (
              <FontAwesomeIcon icon={faSpinner} spin />
            ) : (
              'Regenerate'
            )}
          </button>
        </div>
      </div>
    </div>
  );
};

export default RegenerateDocumentModal;
